// extracted by mini-css-extract-plugin
module.exports = {"__link":"link___link__2Z46G"};